/**
 * 库存相关页面跨路由 / 跨标签页同步。
 * - 同标签：CustomEvent（若后续使用 keep-alive，两页可同时存活并即时刷新）
 * - 跨标签：localStorage + storage 事件
 *
 * @param {string} source 发起端组件名，监听方会忽略自身发出的事件，避免重复请求
 */
export const INVENTORY_CHANGED_EVENT = 'eating-inventory-data-changed'
const LS_KEY = 'eating-inventory-sync-v1'

export function notifyInventoryChanged(source = '') {
  if (typeof window === 'undefined') return
  const payload = { at: Date.now(), source: String(source || '') }
  try {
    window.dispatchEvent(new CustomEvent(INVENTORY_CHANGED_EVENT, { detail: { ...payload } }))
  } catch (e) {}
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(payload))
  } catch (e) {}
}

/**
 * @param {(e: { detail?: { at: number, source: string } }) => void} handler
 * @returns {() => void} 取消订阅
 */
export function onInventoryChanged(handler) {
  if (typeof window === 'undefined') return () => {}

  const onSameTab = (e) => {
    try {
      handler(e)
    } catch (err) {}
  }

  const onStorage = (ev) => {
    if (ev.key !== LS_KEY || !ev.newValue) return
    try {
      const detail = JSON.parse(ev.newValue)
      handler({ type: 'storage', detail })
    } catch (err) {}
  }

  window.addEventListener(INVENTORY_CHANGED_EVENT, onSameTab)
  window.addEventListener('storage', onStorage)
  return () => {
    window.removeEventListener(INVENTORY_CHANGED_EVENT, onSameTab)
    window.removeEventListener('storage', onStorage)
  }
}
